export default __webpack_public_path__ + "static/media/peergroup.76a59156.svg";